/**
 * Created by Ning Jiang on 9/27/2019.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";

export class DTSpinController extends SpinController {

    constructor() {
        super();
    }

    protected getSpinTime():number {
        if(this._mode === GameMode.NORMAL_AVALANCHE || this._mode === GameMode.FREESPIN_AVALANCHE) {
            return 0.1;
        }

        const spinTime:number = GameSetting.isFastSpin ? GameConfig.instance.REEL_FAST_SPIN_SPIN_TIME : GameConfig.instance.REEL_SPIN_TIME;
        if(this._mode === GameMode.FREESPIN) {
            return spinTime;
        }

        return Math.max(spinTime, SpinController.MIN_SPIN_TIME);
    }
}